import request from '@/axios/request';

export function doSsoLogin(data){
  return request({
      url: '/api/login',
      method: 'post',
      data
  })
}

export function getRoleFunList(data){
  return request({
      url: '/api/getRoleFunListByAccountId?accountId=' + data.accountId,
      method: 'get',
  })
}


export function getSysList(data){
  return request({
      url: '/api/getSysListByAccountId?accountId=' + data.accountId,
      method: 'get',
  })
}

export function dologOut(data){
  return request({
      url: '/api/logOut?accountId=' + data.accountId,
      method: 'get',
      data
  })
}

export function getSystemList(data){
  return request({
      url: '/api/LogSearch/LogSearchList',
      method: 'post',
      data
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js